import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@mui/material/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@mui/material/Switch";
import { resumeGame } from "./Game";
import { randDelay, UNLVDate } from "../utils";

const useStyles = makeStyles((theme) => ({
  form: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    width: "fit-content",
  },
  formControlLabel: {
    marginTop: theme.spacing(1),
  },
}));

export default function MaxWidthDialog() {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [lab, setLab] = React.useState("ON");

  const handleClickOpen = () => {
    localStorage.setItem("security_setting", "1");
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    localStorage.setItem("msn_end_time", UNLVDate());
    if (randDelay === 1) { resumeGame(); }
  };

  const handleChange = () => {
    if (lab === "ON") {
      setLab("OFF");
      localStorage.setItem("security_setting", "0");
    } else {
      setLab("ON");
      localStorage.setItem("security_setting", "1");
    }
    localStorage.setItem("setting_change_time", UNLVDate());
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      handleClickOpen();
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <React.Fragment>
      <Dialog disableBackdropClick maxWidth='sm' open={open} onClose={handleClose} aria-labelledby="max-width-dialog-title">
        <DialogTitle id="max-width-dialog-title"><b>Security Setting</b></DialogTitle>
        <DialogContent>
          <DialogContentText style={{ color: "black" }}><b>Allow app to access the data:</b></DialogContentText>
          <form className={classes.form} noValidate>
            <FormControlLabel
              className={classes.formControlLabel}
              control={
                <Switch
                  aria-checked="false"
                  onChange={handleChange}
                  color="error"
                  inputProps={{ "aria-label": "primary checkbox" }}
                />
              }
              label={lab}
            />
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="error">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
